import tx from "@/core/app/tx";

const items = [
    {id: 0, name: tx.t('All'), criteria: {gt: 0}},

    {id: 10,  name: tx.t('Contract-Termination-10'),  nameTx: 'Contract-Termination-10',   criteria: {eq: 10}},
    {id: 20,  name: tx.t('Contract-Termination-20'),  nameTx: 'Contract-Termination-20',   criteria: {eq: 20}},
    {id: 30,  name: tx.t('Contract-Termination-30'),  nameTx: 'Contract-Termination-30',   criteria: {eq: 30}},
    {id: 40,  name: tx.t('Contract-Termination-40'),  nameTx: 'Contract-Termination-40',   criteria: {eq: 40}},
    {id: 50,  name: tx.t('Contract-Termination-50'),  nameTx: 'Contract-Termination-50',   criteria: {eq: 50}},
    {id: 60,  name: tx.t('Contract-Termination-60'),  nameTx: 'Contract-Termination-60',   criteria: {eq: 60}},
    {id: 70,  name: tx.t('Contract-Termination-70'),  nameTx: 'Contract-Termination-70',   criteria: {eq: 70}},
    {id: 200, name: tx.t('Contract-Termination-200'), nameTx: 'Contract-Termination-200',  criteria: {eq: 200}},

];

/*
10 - No vive/viene más a Mallorca
20 - Ya no tiene coche
30 - Compro plaza de garaje
40 - Mal servicio
50 - Precio
60 - No contesta
70 - Cambio tipo contrato/contrato erróneo
200 - Otros
*/


export function getName(value) {

    switch (value) {
        case 0:
        case '0':
            return '?';
        case 10    :
        case "10"    :
            return items[1].name;

        case 20    :
        case "20"    :
            return items[2].name;
        case 30    :
        case "30"    :
            return items[3].name;
        case 40    :
        case "40"    :
            return items[4].name;
        case 50    :
        case "50"    :
            return items[5].name;
        case 60    :
        case "60"    :
            return items[6].name;
        case 70    :
        case "70"    :
            return items[7].name;
        case 200    :
        case "200"    :
            return items[8].name;
        default:
            return value;
    }
}

function translateNames() {
    for (let item of items) {
        item.name = tx.t(item.nameTx);
    }
}


function getItems() {
    return items
}


export default {
    getItems, getName, translateNames
}

